import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Row, Button, Container } from "reactstrap";
import productIcon from "../../../assets/images/product.png";
import ProfileAudience from "./ProfileAudience";
import ProfileTypes from "./ProfileTypes";
import ProfileAnalysis from "./ProfileAnalysis";
import DemographicCard from "./DemographicCard";
import RealLifeInterestsCard from "./RealLifeInterestsCard";
import SalesConsumptionPredictionCard from "./SalesConsumptionPredictionCard";
import showComingSoonAlert from '../../../components/custom/comingSoonAlert';
import BreadCrumb from '../../../components/common/BreadCrumb';
import ReportCreateModal from '../../../components/modal/audience/ReportCreateModal';
import HeatMapCard from './HeatMapCard';
import { useMediaQuery } from "react-responsive";
import { useSelector } from 'react-redux';

const AudienceDetailPage = ({ audienceId, selectedAudience, xx, genderRatios, audienceGeneration, audienceLocation, audiencePurchasing, audienceInterest, probabilitys, toggleDetailPage, topProfileTypes, audienceAnalysis, selectedAudienceData, updateLoading }) => {
    const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
    const navigate = useNavigate();
    const [isReportCreateModalOpen, setIsReportCreateModalOpen] = useState(false);
    const toggleReportCreateModal = () => setIsReportCreateModalOpen(!isReportCreateModalOpen);

    // Access subscriptions from Redux store
    const subscriptions = useSelector(state => state.getPermissionsList.subscriptions);

    // Helper function to check feature availability
    const hasFeature = (feature) => {
        const audienceSubscription = subscriptions?.find(sub => sub.subscriptionType === "AUDIENCE");
        return audienceSubscription?.featureFlags?.[feature] === true;
    };

    return (
        <div className="page-content">
            <Container fluid>
                <BreadCrumb title="Audience Detail" pageTitle="Customer Analytics" />
                <Row style={{ marginBottom: "20px" }}>
                    <Col className="d-flex justify-content-between align-items-center">
                        <Button onClick={toggleDetailPage} className="back-button">
                            <i className="ri-arrow-left-line ri-xl fs-19"></i>Back
                        </Button>
                        <div className="d-flex gap-2">
                            <Button 
                                style={{ width: "190px" }} 
                                color="primary" 
                                onClick={showComingSoonAlert}
                            >
                                Increase Your Sales
                            </Button>
                            <Button 
                                style={{ width: "190px" }} 
                                color="primary" 
                                onClick={() => navigate("/third-party-platforms")}
                            >
                                Acquire More Customers
                            </Button>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <Row className="team-list grid-view-filter">
                            <Col lg={4}>
                                <ProfileAudience selectedAudienceData={selectedAudienceData} />
                            </Col>
                            <Col lg={4}>
                                <ProfileTypes topProfileTypes={topProfileTypes} />
                            </Col>
                            <Col lg={4}>
                                <ProfileAnalysis audienceAnalysis={audienceAnalysis} />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12}>
                        <Row>
                            <Col>
                                <DemographicCard 
                                    xx={xx} 
                                    isBigScreen={isBigScreen} 
                                    genderRatios={genderRatios} 
                                    generationRatios={audienceGeneration} 
                                    locationRatios={audienceLocation} 
                                    Purchasing={audiencePurchasing} 
                                />
                            </Col>
                        </Row>
                    </Col>
                    <Col lg={12}>
                        <Row>
                            <Col>
                                <RealLifeInterestsCard xx={xx} interestRatios={audienceInterest} />
                            </Col>
                            {hasFeature("analytic::sales_prediction") && (
                                <Col>
                                    <SalesConsumptionPredictionCard xx={xx} productIcon={productIcon} probabilitys={probabilitys} />
                                </Col>
                            )}
                        </Row>
                    </Col>
                    <Col lg={12}>
                        <HeatMapCard audienceId={audienceId} />
                    </Col>
                </Row>
            </Container>

            <ReportCreateModal 
                isOpen={isReportCreateModalOpen} 
                toggle={toggleReportCreateModal} 
                selectedAudience={selectedAudience} 
                updateLoading={updateLoading} 
            />
        </div>
    );
};

export default AudienceDetailPage;